import React, { useEffect } from 'react';
import { Space, Switch } from 'antd';
import { useSelector } from 'react-redux';
import { useAtom } from 'jotai';
import { aiAlertAtom, annotationAtom, manualAlertAtom } from '@src/atoms/toggles';
import { track } from '@utils';
import { CLICK_DATE_COMPARISON } from '@src/utils/sensor/track';
import { realTimeModeOnTrendsSelector } from '@store/common/selectors';
import { appAIAlertEnabledSelector } from '@utils/appInsights';
import { isAppModule } from '@utils/constants';
import { prefixedCheckFeature } from '@utils/platform/features/checkFeature';
import { dodAtom } from '../../../metrics-panel-hz/atoms';
import { Header, ToggleText } from './styled';

const cf = prefixedCheckFeature('trends.toggles');

function Toggles() {
  const [manual, setManual] = useAtom(manualAlertAtom);
  const [ai, setAi] = useAtom(aiAlertAtom);
  const [anno, setAnno] = useAtom(annotationAtom);
  const [dod, setDod] = useAtom(dodAtom);

  const liveModeSelected: boolean = useSelector(realTimeModeOnTrendsSelector);
  const isAppAlertEnabled = useSelector(appAIAlertEnabledSelector);

  const onToggleCheck = (setToggle) => (checked) => setToggle(checked);

  const onDodToggle = (checked) => {
    setDod(checked);
    track({ event: CLICK_DATE_COMPARISON });
  };

  // disable on live mode
  useEffect(() => {
    if (liveModeSelected) {
      setDod(false);
      setAi(false);
      setManual(false);
    }
  }, [liveModeSelected]);

  const disabledForAppPOC = !isAppAlertEnabled && isAppModule;

  return (
    <Space direction="vertical">
      <Header>View in Diagnostics</Header>
      <div>
        <Switch
          checked={manual}
          onChange={onToggleCheck(setManual)}
          disabled={isAppModule || liveModeSelected || !cf('manual-alerts', true)}
        />
        <ToggleText>Manual Alerts</ToggleText>
      </div>
      <div>
        <Switch
          checked={ai}
          onChange={onToggleCheck(setAi)}
          disabled={disabledForAppPOC || liveModeSelected || !cf('ai-alerts', true)}
        />
        <ToggleText>AI Alerts</ToggleText>
      </div>
      <div>
        <Switch
          checked={anno}
          onChange={onToggleCheck(setAnno)}
          disabled={!cf('annotations', true)}
        />
        <ToggleText>Annotations</ToggleText>
      </div>
      <div>
        <Switch
          checked={dod}
          onChange={onDodToggle}
          disabled={liveModeSelected || !cf('dod', true)}
        />
        <ToggleText> Date Comparison</ToggleText>
      </div>
    </Space>
  );
}

export default Toggles;
